import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import NewsletterSection from './components/NewsletterSection';
import FAQ from '@/components/feature/FAQ';
import { faqs } from '@/mocks/skincare';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <LatestArticles />

        <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100/70">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                常见问题
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                关于全裸护肤，你最关心的问题都在这里
              </p>
            </div>
            <FAQ items={faqs} />
          </div>
        </section>

        <NewsletterSection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "裸肌研究所",
        "url": "https://jjchuang.cn",
        "description": "全裸护肤理念知识平台，专注极简养肤、成分解析和素颜技巧",
        "inLanguage": "zh-CN",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://jjchuang.cn/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }) }}></script>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "裸肌研究所",
        "alternateName": "Bare Skin Lab",
        "url": "https://jjchuang.cn",
        "description": "科学极简护肤知识平台",
        "email": "hello@jjchuang.cn",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "上海",
          "addressRegion": "静安区",
          "streetAddress": "南京西路1266号恒隆广场2座18层"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "email": "hello@jjchuang.cn"
        }
      }) }}></script>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "全裸护肤真相：素颜肌底的极简养肤法则",
        "description": "全裸护肤理念正在席卷美容界——抛弃层层叠叠的遮盖，回归肌肤本真状态，用极简成分唤醒自然光泽。",
        "url": "https://jjchuang.cn",
        "inLanguage": "zh-CN",
        "isPartOf": { "@type": "WebSite", "name": "裸肌研究所", "url": "https://jjchuang.cn" }
      }) }}></script>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      }) }}></script>
    </>
  );
}